module.exports = __webpack_public_path__ + "static/img/zhenling.3f6dfc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zhenling.png
// module id = ECL+
// module chunks = 24